import React, { useState, useEffect } from "react";
import DashboardLayout from "../DashboardLayout";
import BadgesList from "./badgesList";
import { useNavigate } from "react-router-dom";
import { fetchPaginatedBadgesList } from "../../services/axios/apiManager";
import { handleErrors } from "../../services/dataManager";
import { useAppContext } from "../../services/context";

function Badge() {
  const { state } = useAppContext();
  const { permissions } = state;
  const navigate = useNavigate();
  const [badges, setBadges] = useState([]);
  const [pagination, setPagination] = useState({});

  const [granted, setGranted] = useState([]);

  const extractPermissions = () => {
    const extracted = permissions?.filter((perms) => perms.module === "Badges");
    if (extracted) {
      setGranted(extracted);
    }
  };

  const getData = async () => {
    const res = await fetchPaginatedBadgesList();
    if (res?.data?.success && res?.data?.data) {
      setBadges(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else {
      handleErrors(res, navigate);
    }
  };

  useEffect(() => {
    extractPermissions();
    getData();
  }, []);
  return (
    <DashboardLayout>
      <div data-testid="badges">
        <div className="row">
          <div className="col-12 mb-3">
            <div className="page-title-box d-sm-flex">
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a>Management</a>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    style={{ color: "#8b8b8cbf" }}
                  >
                    Badges
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <BadgesList
          badges={badges}
          setBadges={setBadges}
          pagination={pagination}
          setPagination={setPagination}
          granted={granted}
        />
      </div>
    </DashboardLayout>
  );
}

export default Badge;
